import React from 'react';
import { Base64 } from 'js-base64';
import { useParams } from 'react-router-dom';
import EventRolloutGate from '../../../SocialGalleryV2/EventRolloutGate';
import PilotPassword from './PilotPassword';
import LegacyPassword from './LegacyPassword';

export default function GalleryPasswordEntry() {
  const { id } = useParams();
  let eventId = '';
  try { eventId = Base64.atob(id); } catch (_) { /* Invalid links fail closed. */ }
  return <EventRolloutGate eventId={eventId} pilot={PilotPassword} legacy={LegacyPassword} />;
}
